/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SimpleFilterEntitySchemaMode = typeof SimpleFilterEntitySchemaMode[keyof typeof SimpleFilterEntitySchemaMode];


export const SimpleFilterEntitySchemaMode = {
  include: 'include',
  exclude: 'exclude',
} as const;
